import { AxiosResponse } from 'axios';

import apiClient from '../client';
import { ApiResponseDto } from 'interfaces/apiResponse';
import { CreatePlanDto, PlanDto } from 'interfaces/schedules/plan';

interface EmployeePlanService {
  get(employeeId: string, id: string, queryParams?: any): Promise<PlanDto>;
  update(employeeId: string, id: string, postData: CreatePlanDto): Promise<PlanDto>;
}

const endpoints = {
  get: (employeeId: string, id: string) => `/employees/${employeeId}/schedules/${id}/plan`,
  edit: (employeeId: string, id: string) => `/employees/${employeeId}/schedules/${id}/plan`,
};

export const employeePlanService: EmployeePlanService = {
  get: async (employeeId: string, id: string, queryParams?: any): Promise<PlanDto> => {
    const response: AxiosResponse<ApiResponseDto<PlanDto>> = await apiClient.get(endpoints.get(employeeId, id), {
      params: { ...queryParams },
    });

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  update: async (employeeId: string, id: string, postData: CreatePlanDto): Promise<PlanDto> => {
    const response: AxiosResponse<ApiResponseDto<PlanDto>> = await apiClient.put(endpoints.edit(employeeId, id), postData);

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
};
